import type { Loan } from './types.ts'

export type LoanAccountRole = 'principal' | 'interestPayable' | 'overpayment' | 'interestExpense'

export interface LoanAccount {
  readonly loan: Loan
  readonly role: LoanAccountRole
}

/** Only a loan's own account ids identify its accounts - never an account's class, type or code. */
export function loanAccountsById(loans: readonly Loan[]): ReadonlyMap<string, LoanAccount> {
  const out = new Map<string, LoanAccount>()
  for (const loan of loans) {
    out.set(loan.principalAccountId, { loan, role: 'principal' })
    out.set(loan.interestPayableAccountId, { loan, role: 'interestPayable' })
    out.set(loan.overpaymentAccountId, { loan, role: 'overpayment' })
    out.set(loan.interestExpenseAccountId, { loan, role: 'interestExpense' })
  }
  return out
}
